import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Login'));

function LoadableLogin() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableLogin;
